module.exports = __webpack_public_path__ + "img/podoarttour_main_03.24079b40.jpg";